import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function ReportConcern() {
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();
  
  const queryClient = useQueryClient();

  const [reportMessage, setReportMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reportMessage.trim()) {
      toast.error("The message cannot be empty", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await axios.post(
        `${API_URL}/report-concern-api`,
        { report_message: reportMessage },
        { withCredentials: true }
      );

      if (res.data.Status === "Success") {
        toast.success("Reported successfully", {
          position: "top-right",
          autoClose: 3000,
        });
        setReportMessage(""); // clear textarea
      } else {
        toast.error(res.data.Message || "Report failed", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while submitting your report", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <div className='scrollPageContainer theme-light'>
      <div className='main-wrapper'>
        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

            <div className="row">
              <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                    <p style={{fontWeight: '900', fontSize: '24px'}}>Report a concern </p>
                    You can report any issue, including child abuse, Child Sexual Abuse Material (CSAM), harassment, bullying, threats, and any inappropriate or harmful messages or posts
                </div>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
      <div className="row">

      <div className="col-md-12">
              <div class="card">
                <div class="card-body">

        <textarea
          name="report_message"
          className="form-control"
          rows="4"
          placeholder="Describe your concern..."
          value={reportMessage}
          onChange={(e) => setReportMessage(e.target.value)}
        ></textarea>

        <button
          type="submit"
          className="btn btn-primary mt-2"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Report Now"}
        </button>
      </div>
      </div>
      </div>
      </div>
    </form>


            <div className='row end-page-space'></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportConcern;
